module.exports = __webpack_public_path__ + "static/media/i4.7b54671c.png";